
export interface PaymentRequest {
  mode?: 'LIVE' | 'TEST';
  scriptUrl?: string;
  [key: string]: any;
}

export class WebPayService {
  private scriptLoadPromise: Promise<void> | null = null;

  async loadScript(paymentRequest: PaymentRequest): Promise<void> {
    console.log('Loading WebPay script...');
    
    // Return existing promise if script is already loading
    if (this.scriptLoadPromise) {
      console.log('Script already loading, returning existing promise');
      return this.scriptLoadPromise;
    }

    // If script is already loaded, resolve immediately
    if (typeof window !== 'undefined' && window.webpayCheckout) {
      console.log('WebPay script already loaded');
      return Promise.resolve();
    }

    console.log('Creating new script element');
    this.scriptLoadPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      
      // Always use the live URL as per your working HTML example
      const scriptUrl = paymentRequest.scriptUrl || 'https://newwebpay.interswitchng.com/inline-checkout.js';
      
      console.log('Script URL:', scriptUrl);
      script.src = scriptUrl;
      script.async = true;

      script.onload = () => {
        console.log('Script loaded successfully');
        // Give the script time to initialize
        setTimeout(() => {
          if (window.webpayCheckout) {
            console.log('webpayCheckout function is available');
            resolve();
          } else {
            console.error('webpayCheckout function not found after script load');
            reject(new Error('WebPay script failed to initialize - webpayCheckout not found'));
          }
        }, 1000);
      };

      script.onerror = (error) => {
        console.error('Script loading failed:', error);
        reject(new Error(`Failed to load WebPay script: ${error}`));
      };

      // Remove existing script if any
      const existingScript = document.querySelector('script[src*="inline-checkout.js"]');
      if (existingScript) {
        console.log('Removing existing script');
        existingScript.remove();
      }

      console.log('Appending script to head');
      document.head.appendChild(script);
    });

    return this.scriptLoadPromise;
  }

  async initiatePayment(paymentRequest: PaymentRequest): Promise<void> {
    try {
      console.log('=== INITIATING PAYMENT ===');
      console.log('Payment request:', paymentRequest);
      
      await this.loadScript(paymentRequest);
      
      if (!window.webpayCheckout) {
        throw new Error('WebPay checkout function not available');
      }

      console.log('Calling webpayCheckout with:', paymentRequest);
      
      // Call the WebPay function
      window.webpayCheckout(paymentRequest);
      
      console.log('webpayCheckout called successfully');
      
    } catch (error) {
      console.error('=== PAYMENT INITIATION FAILED ===');
      console.error('Error:', error);
      throw error;
    }
  }
}